import UpdoxApi from './updoxapi';

const headers = { 'Content-Type': 'application/json' };

const getLinks = (successCallback, errorCallback) => {
  return UpdoxApi.getApi(
    '/api/links/list',
    headers,
    successCallback,
    errorCallback,
  )
};

const getUrlForAssociatedLink = (callee, successCallback, errorCallback) => {
  return UpdoxApi.postApi(
      '/api/links/url',
      headers,
      JSON.stringify(callee),
      successCallback,
      errorCallback,
  )
};

const LinksApi = {
  getLinks,
  getUrlForAssociatedLink
};

export default LinksApi;



// WEBPACK FOOTER //
// ./src/apis/links.js